import * as lucideIcons from 'lucide-react';
import { twMerge } from 'tailwind-merge';

export const { icons } = lucideIcons;

const missingIconLog = new Set<string>();

// Nomes usados no sistema que não existem nesta versão do lucide-react: em vez do
// círculo genérico de fallback, um ícone equivalente.
const ICON_ALIASES: Record<string, keyof typeof icons> = {
    Handshake: 'HeartHandshake',
};

interface LucideProps extends React.ComponentPropsWithoutRef<'svg'> {
    icon: keyof typeof icons;
    title?: string;
}

function Lucide(props: LucideProps) {
    const { icon, className, ...computedProps } = props;
    // Rodada 2 (28/10): traço fino e uniforme em todo o sistema (1.5). Quem passar
    // outra espessura na className (stroke-[1.3], stroke-2...) continua mandando.
    const mergedClassName = twMerge(['stroke-[1.5] w-5 h-5', className]);
    const Component = icons[icon] ?? icons[ICON_ALIASES[icon as string]];

    if (!Component) {
        if (!missingIconLog.has(icon)) {
            missingIconLog.add(icon);
            console.warn(`Lucide: ícone "${icon}" não encontrado. Aplicando fallback.`);
        }

        const Fallback = icons.Circle;
        return Fallback ? <Fallback {...computedProps} className={mergedClassName} /> : null;
    }

    return <Component {...computedProps} className={mergedClassName} />;
}

export default Lucide;
